import GlobalPreferenceTooltip from "shared/components/GlobalPreferenceTooltip";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
	return {
		voteCount: state.quickmatch.voteCount,
	};
};

export default connect(mapStateToProps)(GlobalPreferenceTooltip);



// WEBPACK FOOTER //
// ./src/shared/containers/GlobalPreferenceTooltip.js